import { TestAccount, TestAccountCloneProfile } from "../../api/users.interface";

type TestAccountDisplay = Pick<
    TestAccount,
    'uid' | 'avatar' | 'username' | 'name' | 'lastname' | 'email'
> | Pick<
    TestAccountCloneProfile,
    'uid' | 'avatar' | 'username' | 'name' | 'lastname' | 'email'
>;

export const buildTestAccountLabel = (testAccount: TestAccountDisplay): string => {
    const fullName = [testAccount.name, testAccount.lastname]
        .filter(Boolean)
        .join(' ')
        .trim();

    if (fullName) {
        return testAccount.username
            ? `${fullName} (${testAccount.username})`
            : fullName;
    }

    return testAccount.username || testAccount.email || testAccount.uid;
};

export const buildTestAccountStateLabel = (testAccount: TestAccount): string => {
    if (testAccount.currentClonedProfile) {
        return 'Active Clone';
    }

    return 'Original Profile';
};
